<template>

        <a class="skip-link screen-reader-text" href="#primary">Skip to content</a>

        <header id="masthead" class="site-header">
            <div class="container">
                <div class="site-branding">
                    <a :href=" route('minisite.home') " class="custom-logo-link" rel="home"><img
                            width="173" height="38"
                            src="https://www.ewigo.com/wp-content/uploads/2021/08/logo.png" class="custom-logo"
                            alt="EWIGO" /></a> </div><!-- .site-branding -->
                <div class="line"></div>
                <div class="navigation-block">
                    <nav id="site-navigation" class="main-navigation">
                        <button class="menu-toggle" aria-controls="primary-menu" aria-expanded="false">Primary
                            Menu</button>
                        <div class="menu-primary_menu-container">
                            <ul id="primary-menu" class="menu">
                                <li id="menu-item-436"
                                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-436"><a
                                        :href="route('minisite.vendre')">Vendre</a></li>
                                <li id="menu-item-324"
                                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-324"><a
                                        :href="route('minisite.acheter')">Acheter</a></li>
                                <li id="menu-item-324"
                                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-324"><a
                                        :href="route('minisite.services')">Services</a></li>
                                <li id="menu-item-325"
                                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-325"><a
                                    href="https://www.ewigo.com/actualites/">Actualités</a></li>

                                <li id="menu-item-324"
                                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-324"><a
                                    :href="route('minisite.favoris.get')">Mes Favoris</a></li>

                                <!--
                                <li id="menu-item-23"
                                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-23"><a
                                        href="https://ewigo-franchise.com/rejoindre/">Franchise</a></li>
                                <li id="menu-item-130"
                                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-130"><a
                                        href="https://www.ewigo.com/points-de-vente/">Points de vente</a></li>
                                <li id="menu-item-325"
                                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-325"><a
                                        href="https://www.ewigo.com/actualites/">Actualités</a></li>
                                -->
                            </ul>
                        </div>
                    </nav><!-- #site-navigation -->
                </div>
                <div class="menu-icon">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </header><!-- #masthead -->
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
    components: {
        Link,
    },
    props: {
        agency: Object,
        bg_img: String,
    },
    data() {
        return {
            image: {
                backgroundImage: "url('" + this.bg_img + "')"
            }
        };
    }
}
</script>
<style scoped>

ul li {
    margin-bottom: 0 ;
}

</style>
